<script setup>
const appName = process.env.APP_NAME;
const assetUrl = process.env.ASSET_URL;
</script>

<template>
    <div class="w-80 sm:w-100 z-30">
        <a class="relative" href="/">
            <img class="logo-mobile w-full"
                 :src="assetUrl + 'MeritLogo.png'"
                 :alt="appName">
        </a>
    </div>
</template>

<style scoped>

</style>
